import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  // 一覧カード：名前の直下に本文の大きさで
  card: {
    fontSize: 14,
    lineHeight: 1.5,
    marginTop: theme.spacing(0.5),
    overflowWrap: "anywhere",
  },
  // 詳細：ヘッダー（名前・会社名のブロック）の直下に少し大きめで
  detail: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.6,
    marginTop: theme.spacing(2),
    overflowWrap: "anywhere",
  },
}));

/**
 * プランナーのひと言を表示用に整える。未入力・空白だけ・不可視文字だけなら null（行ごと出さない）。
 * 文中の結合文字（絵文字等）は保持する。
 */
export const normalizeBeginnerMessage = (message?: string | null): string | null => {
  const text = typeof message === "string" ? message.trim() : "";
  if (!text || /^[\s\u200B-\u200D\u2060]*$/.test(text)) return null;
  return text;
};

interface AgentBeginnerMessageProps {
  /** プランナー本人が書いた、はじめて不動産投資をする人に向けた一言（40字まで）。古い API では項目自体が無い */
  message?: string | null;
  variant: "card" | "detail";
}

// 「」は画面側で付ける（入力には含めない）。未入力・空白だけなら行ごと出さず、「未設定」などの代わりの文も置かない
export const AgentBeginnerMessage: React.FC<AgentBeginnerMessageProps> = ({ message, variant }) => {
  const classes = useStyles();
  const text = normalizeBeginnerMessage(message);
  if (!text) return null;
  return (
    <Typography className={classes[variant]} data-testid="agent-beginner-message">
      {`「${text}」`}
    </Typography>
  );
};
